import { graphql } from 'react-relay/hooks';

export const productFragment = graphql`
    fragment productFragment_model on Model {
        id
        modelID
        statusID
        name
        code
        providerCode
        salesChannelID
        sourceProductTemplateID
        salesChannel {
            ecommerceSettings {
                ecommerceName
            }
        }
        additionalCodes {
            code
            salesChannelID
            merchantProductName
            salesChannel {
                ecommerceSettings {
                    ecommerceName
                    remoteUrl
                }
            }
        }

        modelColorMappings {
            colorID
            merchantCode
            salesChannelID
        }

        pricingModelID
        largeImageUrl
        smallImageUrl
        provider
        environment
        options {
            optionID
            colorID
            sideID
            optionsData {
                isResizable
                is3DAutoGenEnabled
                isSplitOutput
                startWidth
                minWidth
                maxWidth
                stepWidth
                startHeight
                minHeight
                maxHeight
                maxSizeForSide
                stepHeight
                minArea
                maxArea
                depth
                keepAspectRatio
                lockWidth
                lockHeight
                showWidthSize
                showHeightSize
                showSplitGrid
                mirrorType
                edgesColor
                minSplitWidth
                minSplitHeight
                startSplitColumns
                startSplitRows
                includeBorderInPrintFiles
                backgroundType
                backgroundColor
                backgroundPresetID
                backgroundImageTempUrl
                backgroundImageFileObjectID
                backgroundImageThumbnailFileObjectID
                backgroundImageUrl
                backgroundImageThumbnailUrl
                presets {
                    name
                    width
                    height
                }
                shape
            }
        }
        sceneConfig {
            general {
                arEnabled
                arAnchor
            }
        }
        printTypes {
            printTypeID
            name
            dpi
            patID
            outputTypeID
            patID
            ...modelPrintTypeRestrictionsFragment @relay(mask: false)

            printTypeRestrictionsID
            printTypeRestrictions {
                ...partPrintTypeRestrictionsFragment @relay(mask: false)
            }
        }
        colors {
            colorID
            name
            code
            colorProviderCode
            position
            sides {
                sideID
                name
                imageUrl
                ppcm
                code
                sortOrder
                mandatory
                canRotate
                cameraLocationID
                areas {
                    areaID
                    boundsWidth
                    boundsHeight
                    boundsX
                    boundsY
                    path
                    pathSVG
                    name
                    clipOut
                    guid
                    layers {
                        layerID
                        name
                        displayName
                        description
                        isVisibleInCanvas
                        isVisibleInCart
                        isVisibleInOutput
                        showLabel
                        isClipMask
                        isOutputClipped
                        displayOrder
                        svg
                        json
                    }
                    templateFile {
                        fileObjectID
                        documentWidth
                        documentHeight
                    }
                }
            }
        }
    }
`;

export const productFragmentCompressed = graphql`
    fragment productFragment_modelCompressed on Model {
        id
        statusID
        name
        code
        providerCode
        salesChannelID
        sourceProductTemplateID
        salesChannel {
            ecommerceSettings {
                ecommerceName
            }
        }
        additionalCodes {
            code
            salesChannelID
            merchantProductName
            salesChannel {
                ecommerceSettings {
                    ecommerceName
                    remoteUrl
                }
            }
        }
        modelColorMappings {
            colorID
            merchantCode
            salesChannelID
        }
        pricingModelID
        largeImageUrl
        smallImageUrl
        provider
        environment
        options {
            optionID
            colorID
            sideID
            optionsData {
                isResizable
                is3DAutoGenEnabled
                isSplitOutput
                startWidth
                minWidth
                maxWidth
                stepWidth
                startHeight
                minHeight
                maxHeight
                stepHeight
                maxSizeForSide
                minArea
                maxArea
                depth
                keepAspectRatio
                lockWidth
                lockHeight
                showWidthSize
                showHeightSize
                showSplitGrid
                mirrorType
                edgesColor
                minSplitWidth
                minSplitHeight
                startSplitColumns
                startSplitRows
                includeBorderInPrintFiles

                backgroundType
                backgroundColor
                backgroundPresetID
                backgroundImageTempUrl
                backgroundImageFileObjectID
                backgroundImageThumbnailFileObjectID
                backgroundImageUrl
                backgroundImageThumbnailUrl

                presets {
                    name
                    width
                    height
                }
                shape
            }
        }
        sceneConfig {
            general {
                arEnabled
                arAnchor
            }
        }
        printTypes {
            printTypeID
            name
            dpi
            patID
            outputTypeID
            patID
            ...modelPrintTypeRestrictionsFragment @relay(mask: false)

            printTypeRestrictionsID
            printTypeRestrictions {
                ...partPrintTypeRestrictionsFragment @relay(mask: false)
            }
        }
        modelColorsCompressed
    }
`;
